import { isAxiosError } from 'axios';
import { VrioOttError } from '../VrioOttError.js';
import { ErrorCode } from '../types.js';
import { getErrorCodeFromAxiosError } from './utils.js';

function createErrorInterceptor(errorFactory, options) {
  return async (error) => {
    if (error instanceof VrioOttError) {
      throw error;
    }
    if (isAxiosError(error)) {
      throw errorFactory.createFromAxiosError(error, {
        source: options.source,
        code: getErrorCodeFromAxiosError(error, options),
        externCode: error.response && options.getExternCode(error.response),
        getResponseMessage: options.getResponseMessage
      });
    }
    throw errorFactory.createFromError(error, {
      source: options.source,
      code: ErrorCode.UNEXPECTED_ERROR
    });
  };
}

export { createErrorInterceptor };
//# sourceMappingURL=interceptor.js.map
